import { put, takeLatest } from "redux-saga/effects";
import DashboardReq from "../../../Utility/Requester/DashboardReq";
import actions from "../../actions";

export default function* sessions() {
  yield takeLatest(
    actions.dashboard.sessions.FETCH_SESSIONS_REQUEST,
    function* ({ role, params }) {
      try {
        const response = yield DashboardReq.GetSession(role, params);
        yield put({
          type: actions.dashboard.sessions.FETCH_SESSIONS_SUCCESS,
          payload: response.data,
        });
      } catch (error) {
        yield put({
          type: actions.dashboard.sessions.FETCH_SESSIONS_ERROR,
        });
      }
    }
  );
}
